module.exports = __webpack_public_path__ + "img/bz08.2dee292d.png";